$(function(){
  var $thumbListImgs = $(".marutsu-product__thumb-list-img");
  $thumbListImgs.eq(0).addClass("is-active");

  $(".marutsu-product__thumb-slider").on("afterChange", function(event, slick, currentSlide){
    $(this).closest(".marutsu-product__thumb").find(".marutsu-product__thumb-current").text(currentSlide + 1);
    $thumbListImgs.removeClass("is-active").eq(currentSlide).addClass("is-active");
  });

  $(".marutsu-product__thumb-slider").slick({
    infinite: false,
    slidesToShow: 1,
  });

  $thumbListImgs.on("click", function(){
    var index = $(this).index();
    $(this).closest(".marutsu-product__left").find(".marutsu-product__thumb-slider").slick("slickGoTo", index);
  });

  if(window.matchMedia('screen and (min-width: 1025px)').match){
    $(".marutsu-product__thumb img").imagezoomsl({
      //以下オプション
      classmagnifier: window.external ? "round-loope" : "", //CSSで拡大枠の形状を変更
      cursorshadeborder: "10px solid #000", //カーソル枠の太さ・形状・色
      descarea: ".my-container", //クラス指定した場所に拡大画像を表示
      innerzoom: true, //インナーズーム
      innerzoommagnifier: true, //インナーズームの別バージョン
      loopspeedanimate: 1, //カーソルの追従速度
      magnifierborder: "none",  //カーソル枠の有無
      magnifiereffectanimate: "fadeIn", //拡大画像のアニメーション。他にslideIn
      magnifierpos: "left", //拡大画像の位置。他にright
      magnifiersize: [340, 340], //拡大画像のサイズ。絶対値
      scrollspeedanimate: 1, //カーソル移動時の拡大画像の追従速度
      zoomrange: [1, 5],　//ズームのレンジ 1-10倍
      zoomstart: 3, //ズームの開始値
    });
  }
  $(".marutsu-product__media").click(function(){
    var index = $(this).index();
    $(this).closest(".marutsu-product").find(".marutsu-product__thumb.sp-only .marutsu-product__thumb-slider").slick("slickGoTo", index);
    return false;
  });
});